<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home">
        <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3" cols-xl="3">
          <b-col v-if="trophy.createdBy" class="text-center margin-top-bottom">
            <div class="margin-bottom">
              Club:
              <router-link class="text-black" :to="{ name: 'Club', params: { id: trophy.club.id }}">
                <b>{{ trophy.club.name }}</b> 
              </router-link>
            </div>
            Created by 
            <br>
            <router-link class="text-black" :to="{ name: 'Rider', params: { id: trophy.createdBy.id }}">
              <b>{{ trophy.createdBy.stravaDetails.firstname }} {{ trophy.createdBy.stravaDetails.lastname }}</b>
              &nbsp;<b-badge pill variant="primary">{{ trophy.createdBy.level }}</b-badge>
              <br>
              <img v-if="trophy.createdBy.stravaDetails.profile" :src="trophy.createdBy.stravaDetails.profile" width="50px">
              <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
            </router-link>
          </b-col>
          <b-col class="margin-top-bottom text-center">
            <div class="inline">
              <img src="../../public/trophyseries.png" width="120px">
              <span class="bigger-font-x2 margin-left">{{ trophy.name }}</span>
            </div>
            <br><br>
            <div v-if="!trophy.validated" class="text-center failure">
              <h5>Status: Waiting for approval</h5>
              <span>The trophy is not public yet. It must be approved by an admin. The creator will be notified by email when it's approved</span>
            </div>
            <div v-else class="text-center">
              <a @click.prevent="viewRules()" class="text-blue">How to join the trophy?</a>
            </div>
          </b-col>
          <b-col class="text-center margin-top-bottom">
            <div v-if="!isUserRegisteredOnTrophy" class="center-align">
              <div v-if="isTrophyOver">
                Trophy is over
              </div>
              <div v-else>
                <c-button :onClick="onRegister" variant="primary">Register now</c-button>
                <br>
                <span class="success">{{ registerSuccess }}</span>
                <span class="failure">{{ registerFailure }}</span>
              </div>
            </div>
            <div v-else class="center-align">
              You are registered on the trophy
              <br>
              <br>
              <div>
              Share trophy:
                <a><fa-icon :icon="['far', 'copy']" @click="copyToClipboard(trophyLink)"/></a>
              </div>
            </div>
          </b-col>
        </b-row>
        <br>
        <span class="failure">{{ failureMessage }}</span>
        <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4" class="text-center">
          <b-col>
            <b>Participants:</b> {{ trophy.riders }}
          </b-col>
          <b-col>
            <b>Races:</b> {{ trophy.racesTrophy ? trophy.racesTrophy.length : null }}
          </b-col>
          <b-col>
            <b>Start date:</b> {{ trophy.startDate | date }}
          </b-col>
          <b-col>
            <b>End date:</b> {{ trophy.endDate | date }}
          </b-col>
        </b-row>
        <br>
        <div>
          <div id="map" class="map"></div>
        </div>
        <br>
        <br>

        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col>
            <div class="text-center"><h4 class="inline">Ranking</h4>&nbsp;&nbsp;(Total riders: {{ usersOnTrophyPagination.count }})</div>
            <b-table :fields="fields2" :items="usersOnTrophy" responsive="sm">
              <template #cell(rank)="data">
                <b>{{ data.item.rank }}</b>
              </template>

              <template #cell(rider)="data">
                <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.user.id }}">
                  <img v-if="data.item.user.stravaDetails.profile" :src="data.item.user.stravaDetails.profile" width="25px">
                  <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                  <b class="margin-left">{{ data.item.user.stravaDetails.firstname }} {{ data.item.user.stravaDetails.lastname }}</b>
                </router-link>
                &nbsp;<b-badge pill variant="primary">{{ data.item.user.level }}</b-badge>
              </template>

              <template 
                v-for="raceTrophy in racesTrophy"
                v-slot:[head(raceTrophy.id)]="data"
              >
                <span v-bind:key="raceTrophy.id">
                  {{ data.label }}
                </span>
              </template>

              <template 
                v-for="raceTrophy in racesTrophy"
                v-slot:[cell(raceTrophy.id)]="data"
              >
                <span v-bind:key="raceTrophy.id">
                  <b v-if="getRaceAttemptTrophy(data.item.raceAttemptsTrophy, raceTrophy.id).rank"><a @click.prevent="viewRaceResults(raceTrophy.race, data.item.user.id)">{{ getRaceAttemptTrophy(data.item.raceAttemptsTrophy, raceTrophy.id).points }} <span class="smaller-font-2">(Pos {{ getRaceAttemptTrophy(data.item.raceAttemptsTrophy, raceTrophy.id).rank }})</span></a></b>
                </span>
              </template>

              <template #cell(points)="data">
                <b>{{ data.item.points }}</b>
              </template>
            </b-table>
            <div class="center-align">
              <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getTrophyRanking', 'usersOnTrophyPagination')"/>
              Page: {{ usersOnTrophyPagination.page }} / {{ usersOnTrophyPagination.totalPages }}
              <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getTrophyRanking', 'usersOnTrophyPagination')"/>
            </div>
          </b-col>
        </b-row>

        <br>
        <br>

        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2" cols-xl="2">
            <b-col>
              <div class="text-center">
                <div class="inline">
                  <span class="bigger-font-x2">Races</span>
                  &nbsp;
                  <img src="../../public/flag.png" width="25px">
                </div>
              </div>
              <b-table :fields="fields1" :items="trophy.racesTrophy" responsive="sm">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                  <template #cell(name)="data">
                    <router-link class="text-black" :to="{ name: 'Race', params: { id: data.item.race.id }}">
                      <b>{{ data.item.race.name }}</b>
                      <span v-if="data.item.race.isEBike">&nbsp;<img src="../../public/thunder.png" width="15px"></span>
                    </router-link>
                  </template>

                <template #cell(startDate)="data">
                  {{ data.item.startDate | date }}
                </template>

                <template #cell(endDate)="data">
                  {{ data.item.endDate | date }}
                </template>

                <template #cell(stages)="data">
                  {{ numberOfStages(data.item.race.itineary) }}
                </template>
                
                <template #cell(distance)="data">
                  {{ metersToKilometers(data.item.race.recommendedRoute.stravaDetails.distance) }} km
                </template>

                <template #cell(elevation)="data">
                  {{ meters(data.item.race.recommendedRoute.stravaDetails.elevation_gain) }} m
                </template>

                <template #cell(raceRanking)="data">
                  <a @click.prevent="viewRaceResults(data.item.race)">View race results</a>
                </template>
              </b-table>
            </b-col>
            <b-col>
              <h4 class="text-center"><span v-if="!isTrophyOver">Provisional </span>Podium</h4>
              <div class="podium">
                <table class="table-center">
                  <tr>
                    <td class="text-center">
                      <div id="podium1">
                        <h1>{{ secondOnPodium.rank }}</h1>
                        <router-link class="text-black" :to="{ name: 'Rider', params: { id: secondOnPodium.id }}">
                          <img v-if="secondOnPodium.photo" :src="secondOnPodium.photo" width="50px">
                          <img v-else-if="secondOnPodium.id" src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
                          <br>
                          {{ secondOnPodium.name }}
                        </router-link>
                      </div>
                    </td>
                    <td class="text-center">
                      <div id="podium0">
                        <h1>{{ firstOnPodium.rank }}</h1>
                        <router-link class="text-black" :to="{ name: 'Rider', params: { id: firstOnPodium.id }}">
                          <img v-if="firstOnPodium.photo" :src="firstOnPodium.photo" width="60px">
                          <img v-else-if="firstOnPodium.id" src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="60px">
                          <br>
                          {{ firstOnPodium.name }}
                        </router-link>
                      </div>
                    </td>
                    <td class="text-center">
                      <div id="podium2">
                        <h1>{{ thirdOnPodium.rank }}</h1>
                        <router-link class="text-black" :to="{ name: 'Rider', params: { id: thirdOnPodium.id }}">
                          <img v-if="thirdOnPodium.photo" :src="thirdOnPodium.photo" width="40px">
                          <img v-else-if="thirdOnPodium.id" src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="40px">
                          <br>
                          {{ thirdOnPodium.name }}
                        </router-link>
                      </div>
                    </td>
                  </tr>
              </table>
              </div>
            </b-col>
        </b-row>

        <b-modal ref="raceRanking" size="xl" title="Race ranking" hide-footer>
          <div class="d-block">
            <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
              <b-col>
                <span class="failure">{{ raceRankingFailureMessage }}</span>
                <div class="text-center">
                  <h4 class="inline">
                    <router-link class="text-black" :to="{ name: 'Race', params: { id: openedInModalRace.id }}">
                      <b>{{ openedInModalRace.name }}</b>
                    </router-link>
                  </h4>
                  &nbsp;&nbsp;(Total riders: {{ raceRankingPagination.count }})
                </div>
                <b-table :fields="fields3" :items="raceRanking" responsive="sm">
                  <template #cell(rank)="data">
                    <b>{{ data.item.rank }}</b>
                  </template>

                  <template #cell(points)="data">
                    {{ data.item.points }}
                  </template>

                  <template #cell(rider)="data">
                    <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.raceAttempt.user.id }}">
                      <img v-if="data.item.raceAttempt.user.stravaDetails.profile" :src="data.item.raceAttempt.user.stravaDetails.profile" width="25px">
                      <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                      <b class="margin-left">{{ data.item.raceAttempt.user.stravaDetails.firstname }} {{ data.item.raceAttempt.user.stravaDetails.lastname }}</b>
                    </router-link>
                    &nbsp;<b-badge pill variant="primary">{{ data.item.raceAttempt.user.level }}</b-badge>
                  </template>

                  <template #cell(startDate)="data">
                    {{ data.item.raceAttempt.startDate | date }}
                  </template>

                  <template 
                    v-for="stage in openedInModalRaceStages"
                    v-slot:[head(stage.id)]="data"
                  >
                    <span v-bind:key="stage.id">
                      {{ data.label }}
                    </span>
                  </template>

                  <template 
                    v-for="stage in openedInModalRaceStages"
                    v-slot:[cell(stage.id)]="data"
                  >
                    <span v-bind:key="stage.id">
                      {{ data.item.raceAttempt.details | getStageTime(stage.number) }}
                    </span>
                  </template>
                  
                  <template #cell(penaltyTime)="data">
                    <i>{{ data.item.raceAttempt.penaltyTime | secondsToMinutes }}</i>
                  </template>

                  <template #cell(finalTime)="data">
                    <b>{{ data.item.raceAttempt.finalTime | secondsToMinutes }}</b>
                  </template>

                  <template #cell(activity)="data">
                    <a :href="`https://www.strava.com/activities/${data.item.raceAttempt.activity.stravaActivityId}`" target="_blank" class="strava smaller-font">
                      View on Strava
                    </a>
                  </template>
                </b-table>
                <div class="center-align">
                  <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getRaceRanking', 'raceRankingPagination')"/>
                  Page: {{ raceRankingPagination.page }} / {{ raceRankingPagination.totalPages }}
                  <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getRaceRanking', 'raceRankingPagination')"/>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-modal>

        <b-modal ref="rules" title="How to join a trophy?" hide-footer>
          <div class="d-block">
            <p>To join a trophy, you must first create an account on EnduroBiking.com. Click <router-link :to="{ name: 'SignUp'}">here</router-link> to create an account.</p>
            <p>Once you are logged in, search on EnduroBiking.com for the trophy you are willing to do. On the trophy, click on "Register now".</p>
            <p>Analyze the trophy: look at the races that are part of the trophy, and when each race has to done.</p>
            <p>When it is time to do the first race, do like you would do on any race on EnduroBiking.com:</p>
            <p>Launch an activity on Strava, take your bike and go ride the race. When you are back, publish your activity with public confidentiality.</p>
            <p>If you have done the race within the right dates, you will score points on the trophy. You can see yourself on the trophy leaderboard.</p>
            <p>Enjoy, and have a safe ride!</p>
          </div>
        </b-modal>

        <b-modal ref="eventsAtLocation" title="Races at this location" hide-footer>
          <div class="d-block">
            <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
              <b-col 
                v-for="event in eventsAtLocation"
                :key="event.id"
                class="margin-top-bottom"
              >
                <div>
                  <router-link class="text-black text-decoration-none" :to="{ name: 'Race', params: { id: event.id }}">
                    <b-card>
                      <b-card-text>
                        <img src="../../public/flag.png" width="25px">&nbsp;
                        <h5 class="inline">{{event.name }}</h5>
                        <span v-if="event.isEBike">&nbsp;<img src="../../public/thunder.png" width="20px"></span>
                        <br>
                        <br>
                        <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                          <b-col>
                            <b>Dates:</b> {{ event.dates }}
                            <br><br>
                            <b>Stages:</b> {{event.stages }}
                          </b-col>
                          <b-col>
                            <b>Distance:</b> {{ event.distance }} km
                            <br><br>
                            <b>Elevation:</b> {{ event.elevation }} m
                          </b-col>
                        </b-row>
                      </b-card-text>
                    </b-card>
                  </router-link>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Trophy',
    components: { CButton },
    props: {
      id: String
    },
    data() {
      return {
        failureMessage: '',
        attemptsFailureMessage: '',
        trophy: {},
        racesTrophy: [],
        fields1: [
          {
            key: 'index',
            label: 'Order'
          },
          {
            key: 'name'
          },
          {
            key: 'startDate',
            label: 'Start date'
          },
          {
            key: 'endDate',
            label: 'End date'
          },
          {
            key: 'stages',
          },
          {
            key: 'distance',
          },
          {
            key: 'elevation',
          },
          {
            key: 'raceRanking',
            label: 'Results'
          }
        ],
        registerSuccess: '',
        registerFailure: '',
        isUserRegisteredOnTrophy: false,
        usersOnTrophy: [],
        fields2: [
          {
            key: 'rank'
          },
          {
            key: 'rider'
          },
          {
            key: 'points',
            label: 'Trophy Points'
          }
        ],
        usersOnTrophyPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        raceRanking: [],
        raceRankingFailureMessage: '',
        raceRankingPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null,
          payload: {}
        },
        openedInModalRace: {},
        openedInModalRaceStages: [],
        fields3: [
          {
            key: 'rank'
          },
          {
            key: 'points'
          },
          {
            key: 'rider'
          },
          {
            key: 'startDate',
            label: 'Date'
          },
          {
            key: 'penaltyTime',
            label: 'Penalty'
          },
          {
            key: 'finalTime'
          },
          {
            key: 'activity'
          },
        ],
        eventsAtLocation: null
      }
    },
    async created() {

    },
    async mounted() {
      await this.getTrophy()
      if (this.user && this.user.email) await this.getUserOnTrophy()
      await this.getTrophyRanking()
    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      isTrophyOver() {
        if (this.trophy.endDate) {
          const endDateTrophy = new Date(this.trophy.endDate)
          const now = new Date()
          if (endDateTrophy < now) return true
        }
        return false
      },
      firstOnPodium() {
        if (this.usersOnTrophy[0]) {
          return { 
            rank: this.usersOnTrophy[0].rank, 
            name: `${this.usersOnTrophy[0].user.stravaDetails.firstname} ${this.usersOnTrophy[0].user.stravaDetails.lastname}`,
            photo: this.usersOnTrophy[0].user.stravaDetails.profile,
            id: this.usersOnTrophy[0].user.id
          }
        }
        return {}
      },
      secondOnPodium() {
        if (this.usersOnTrophy[1]) {
          return { 
            rank: this.usersOnTrophy[1].rank, 
            name: `${this.usersOnTrophy[1].user.stravaDetails.firstname} ${this.usersOnTrophy[1].user.stravaDetails.lastname}`,
            photo: this.usersOnTrophy[1].user.stravaDetails.profile,
            id: this.usersOnTrophy[1].user.id
          }
        }
        return {}
      },
      thirdOnPodium() {
        if (this.usersOnTrophy[2]) {
          return { 
            rank: this.usersOnTrophy[2].rank, 
            name: `${this.usersOnTrophy[2].user.stravaDetails.firstname} ${this.usersOnTrophy[2].user.stravaDetails.lastname}`,
            photo: this.usersOnTrophy[2].user.stravaDetails.profile,
            id: this.usersOnTrophy[2].user.id
          }
        }
        return {}
      },
      trophyLink() {
        return `${process.env.VUE_APP_FRONT_URL}/trophy/${this.id}`
      }
    },
    methods: {
      head: (id) => `head(${id})`,
      cell: (id) => `cell(${id})`,
      async viewRaceResults(race, userId) {
        await this.getRaceRanking({ race, userId });
        this.showModal('raceRanking');
      },
      showModal(name) {
        if (Array.isArray(this.$refs[name])) {
          this.$refs[name][0].show()
        } else {
          this.$refs[name].show()
        }
      },
      viewRules() {
        this.showModal('rules');
      },
      viewEventsAtLocation(markers) {
        this.eventsAtLocation = markers
        this.showModal('eventsAtLocation');
      },
      async getRaceRanking({ race, userId }) {
        this.raceRankingFailureMessage = ''
        this.raceRanking = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRaceTrophyRanking.graphql'),
          variables: {
            raceId: race.id,
            trophyId: this.id,
            userId: userId ? userId : this.user ? this.user.id : undefined,
            page: this.raceRankingPagination.page,
            itemsPerPage: this.raceRankingPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.raceRankingFailureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRaceTrophyRanking) {
          this.raceRanking.push(...result.data.getRaceTrophyRanking.raceAttemptsTrophy)
          this.raceRankingPagination.count = result.data.getRaceTrophyRanking.pagination.count
          this.raceRankingPagination.totalPages = result.data.getRaceTrophyRanking.pagination.totalPages
          this.raceRankingPagination.payload = { race, userId }

          const userIdToCheck = userId ? userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.raceRanking.length; i++) {
              const rank = this.raceRanking[i];
              if (rank.raceAttempt.user.id === userIdToCheck) rank._rowVariant = 'primary'
            }
          }

          this.openedInModalRace = race

          for (let i=0; i < this.openedInModalRace.itineary.length; i++) {
            const step = this.openedInModalRace.itineary[i]
            if (step.type === 'stage') {

              const stageId = `stage-${step.number}`
              const stageName = `Stage ${step.number}`
              
              this.openedInModalRaceStages.push({
                id: stageId,
                name: stageName,
                number: step.number,
              })

              this.fields3.splice(3 + step.number, 0, {
                key: stageId,
                label: stageName
              })
            }
          }
        }
      },
      async getTrophy() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getTrophy.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getTrophy) {
          this.trophy = Object.assign({}, this.trophy, result.data.getTrophy)

          for (let i = 0; i < this.trophy.racesTrophy.length; i++) {
            const raceTrophy = this.trophy.racesTrophy[i]
            this.racesTrophy.push(raceTrophy)

            this.fields2.splice(2 + i, 0, {
              key: raceTrophy.id,
              label: `Race ${i+1}`
            })
          }

          const mapData = {
            center: [this.trophy.location.longitude, this.trophy.location.latitude],
            races: this.trophy.racesTrophy.map((raceTrophy, index) => {
              return {
                'type': 'Feature',
                'geometry': {
                  'type': 'Point',
                  'coordinates': [raceTrophy.race.location.longitude, raceTrophy.race.location.latitude]
                },
                'properties': {
                  'title': `Race ${index + 1}`,
                  'id': raceTrophy.race.id,
                  'isEBike': raceTrophy.race.isEBike,
                  'name': raceTrophy.race.name,
                  'dates': `${this.$options.filters.date(raceTrophy.startDate)} - ${this.$options.filters.date(raceTrophy.endDate)}`,
                  'stages': this.numberOfStages(raceTrophy.race.itineary),
                  'distance': this.metersToKilometers(raceTrophy.race.recommendedRoute.stravaDetails.distance),
                  'elevation': this.meters(raceTrophy.race.recommendedRoute.stravaDetails.elevation_gain),
                }
              }
            })
          }

          this.loadMap(mapData)
        }
      },
      loadMap({ center, races }) {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_API_KEY;

        const map = new mapboxgl.Map({
          container: 'map',
          zoom: 6,
          center,
          pitch: 0,
          bearing: 0,
          style: 'mapbox://styles/marcvander/ckvuz25zg3gqz14t7m63owekh'
        });

        const that = this

        map.on('load', () => {                    

          map.loadImage(
            'https://cdn-icons-png.flaticon.com/32/1505/1505471.png',
            (error, image) => {
              if (error) throw error;
              map.addImage('race', image);

              map.addSource('races', {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': races
                },
                cluster: true,
                clusterMaxZoom: 25, // Max zoom to cluster points on
                clusterRadius: 50 // Radius of each cluster when clustering points 
              });

              map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'races',
                filter: ['has', 'point_count'],
                paint: {
                  // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                  // with three steps to implement three types of circles:
                  //   * Blue, 20px circles when point count is less than 5
                  //   * Yellow, 30px circles when point count is between 5 and 20
                  //   * Pink, 40px circles when point count is greater than or equal to 20
                  'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    '#ffc859',
                    5,
                    '#ffc859',
                    20,
                    '#ffc859'
                  ],
                  'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    5,
                    25,
                    20,
                    30
                  ]
                }
              });

              map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'races',
                filter: ['has', 'point_count'],
                layout: {
                  'text-field': '{point_count_abbreviated}',
                  'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                  'text-size': 12
                }
              });

              map.addLayer({
                'id': 'races',
                'type': 'symbol',
                'source': 'races',
                filter: ['!', ['has', 'point_count']],
                'layout': {
                  'icon-image': 'race',
                  'icon-allow-overlap': true,
                  'text-field': ['get', 'title'],
                  'text-font': [
                    'Open Sans Semibold',
                    'Arial Unicode MS Bold'
                  ],
                  'text-offset': [0, 0],
                  'text-anchor': 'top'
                },
                'paint': {
                  'text-color': '#000000',
                }
              })

              const that = this

              // inspect a cluster on click
              map.on('click', 'clusters', (e) => {
                const features = map.queryRenderedFeatures(e.point, {
                  layers: ['clusters']
                });
                const clusterId = features[0].properties.cluster_id;
                map.getSource('races').getClusterExpansionZoom(
                  clusterId,
                  (err, expansionZoom) => {
                    if (err) return;

                    const currentZoom = map.getZoom();
                    if (currentZoom < 15) {
                      map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: expansionZoom
                      });
                    } else {
                      map.getSource('races').getClusterLeaves(
                        clusterId,
                        100,
                        0,
                        function (err, leafFeatures) {
                          if (err) {
                            return console.error('error while getting leaves of a cluster', err);
                          }
                          const markers = _.map(leafFeatures, function(leafFeature) {
                            return leafFeature.properties;
                          });

                          that.viewEventsAtLocation(markers)
                        }
                      );
                    }
                  }
                );
              });

              // When a click event occurs on a feature in the places layer, open a popup at the
              // location of the feature, with description HTML from its properties.
              map.on('click', 'races', (e) => {
                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();
                const id = e.features[0].properties.id;
                const bikeType = e.features[0].properties.isEBike ? '(E-Bike)' : '';
                const name = e.features[0].properties.name;
                const title = e.features[0].properties.title;
                const dates = e.features[0].properties.dates;
                const stages = e.features[0].properties.stages;
                const distance = e.features[0].properties.distance;
                const elevation = e.features[0].properties.elevation;

                const html = `
                  <strong>${title}: ${name}</strong>&nbsp;${bikeType}
                  <p> 
                    <b>Dates:</b> ${dates}
                    <br>
                    <b>Stages:</b> ${stages}
                    <br>
                    <b>Distance:</b> ${distance} km
                    <br>
                    <b>Elevation:</b> ${elevation} m
                    <br>
                    <a href=${process.env.VUE_APP_FRONT_URL}/race/${id}><strong>View</strong></a>
                  </p>
                `
                
                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
                
                new mapboxgl.Popup()
                  .setLngLat(coordinates)
                  .setHTML(html)
                  .addTo(map);
              });
              
              // Change the cursor to a pointer when the mouse is over the places layer.
              map.on('mouseenter', 'races', () => {
                map.getCanvas().style.cursor = 'pointer';
              });
              
              // Change it back to a pointer when it leaves.
              map.on('mouseleave', 'races', () => {
                map.getCanvas().style.cursor = '';
              });
            }
          )
        })
      },
      async getUserOnTrophy() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getUserOnTrophy.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            trophyId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getUserOnTrophy) {
          if (result.data.getUserOnTrophy.id) {
            this.isUserRegisteredOnTrophy = true
          }
        }
      },
      async onRegister(event) {
        if (!this.user || !this.user.email) this.$router.push({ name: 'SignUp' });

        this.registerSuccess = ''
        this.registerFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/addUserToTrophy.graphql'),
          variables: {
            trophyId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.registerFailure = e.body.message;
            }
          }
        } else {
          this.registerSuccess = "You are successfully registered to the trophy";

          await this.getUserOnTrophy()
          await this.getTrophyRanking()
        }
      },
      async getTrophyRanking() {
        this.usersOnTrophy = []

        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getTrophyRanking.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            trophyId: this.id,
            page: this.usersOnTrophyPagination.page,
            itemsPerPage: this.usersOnTrophyPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getTrophyRanking) {
          this.usersOnTrophy.push(...result.data.getTrophyRanking.usersTrophy)
          this.usersOnTrophyPagination.count = result.data.getTrophyRanking.pagination.count
          this.usersOnTrophyPagination.totalPages = result.data.getTrophyRanking.pagination.totalPages

          const userIdToCheck = this.userId ? this.userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.usersOnTrophy.length; i++) {
              const rank = this.usersOnTrophy[i];
              if (rank.user.id === userIdToCheck) rank._rowVariant = 'primary'
            }
          }
        }
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
      meters(value) {
        return value.toFixed(0)
      },
      metersToKilometers(value) {
        return (value / 1000).toFixed(2)
      },
      numberOfStages(itineary) {
        return itineary.filter(step => step.type === 'stage').length
      },
      getRaceAttemptTrophy(raceAttemptsTrophy, raceTrophyId) {
        for (let i = 0; i < raceAttemptsTrophy.length; i++) {
          const raceAttemptTrophy = raceAttemptsTrophy[i]
          if (raceAttemptTrophy.raceTrophyId === raceTrophyId) return raceAttemptTrophy
        } 
        return {}
      },
      copyToClipboard(val) {
        this.$copyText(val).then(function () {
          alert('Copied')
        }, function () {
          alert("Couldn't copy to clipboard")
        })
      },
    }
  }
</script>

<style scoped>

</style>
